<template>
  <div class="keep-alive">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!--不缓存的视图-->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <template></template>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
export default {
  mounted() {
    config()
  }
};
</script>
<style lang='scss' scoped>
.keep-alive {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>